/* Silvery Silver product page behaviour.
   Works alongside Dawn's product-info.js / product-form.js / media-gallery.js and never replaces them:
   - size label: mirrors the selected size next to the "Size guide" link
   - quantity: caps the stepper at available stock (data-max) and hides it when only one can be bought
   - mobile sticky purchase bar: always shown on mobile product pages; forwards taps to the native Add to cart and
     Shopify Buy it now buttons
   - gallery dots, share links, recently viewed (browser storage only) */
(function () {
  'use strict';

  var RECENT_KEY = 'ss_recently_viewed';

  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(handle) {
    if (!handle) return;
    try {
      var list = readRecent().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 10)));
    } catch (e) {
      /* storage unavailable: recently viewed simply stays hidden */
    }
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- Recently viewed ---------- */
  function initRecent(section) {
    var list = section.querySelector('[data-ss-recent-list]');
    if (!list) return;
    var current = section.getAttribute('data-current');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var handles = readRecent().filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '?section_id=ss-card-render')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (text) {
            if (!text) return null;
            var doc = new DOMParser().parseFromString(text, 'text/html');
            return doc.querySelector('[data-ss-card-render] .ss-card');
          })
          .catch(function () { return null; });
      })
    ).then(function (cards) {
      var count = 0;
      cards.forEach(function (card) {
        if (!card) return;
        var li = document.createElement('li');
        li.className = 'ss-rail__item';
        li.appendChild(document.importNode(card, true));
        list.appendChild(li);
        count += 1;
      });
      if (count > 0) section.hidden = false;
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var sid = root.getAttribute('data-section');
    var mqMobile = window.matchMedia('(max-width: 749px)');

    function sizeMsg(show) {
      var msg = root.querySelector('[data-ss-size-msg]');
      if (msg) msg.hidden = !show;
    }

    // Size label next to the size guide
    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('variant-selects input[type="radio"]')) return;
      if (input.closest('[data-ss-size-group]')) {
        var label = root.querySelector('[data-ss-size-value]');
        if (label) label.textContent = input.getAttribute('data-ss-label') || input.value;
      }
      sizeMsg(false);
    });

    // Quantity cap
    function applyQty() {
      var input = root.querySelector('.quantity__input');
      var wrap = root.querySelector('[data-ss-qty]');
      if (!input || !wrap) return;
      var max = parseInt(input.getAttribute('data-max'), 10);
      var inCart = parseInt(input.getAttribute('data-cart-quantity') || '0', 10) || 0;
      var min = parseInt(input.getAttribute('data-min') || '1', 10) || 1;
      if (isNaN(max)) {
        wrap.hidden = false;
      } else {
        wrap.hidden = max <= 1;
        var allowed = Math.max(max - inCart, 0);
        if (allowed > 0) {
          input.max = allowed;
          input.min = Math.min(min, allowed);
          var value = parseInt(input.value, 10);
          if (isNaN(value) || value < input.min) input.value = input.min;
          if (parseInt(input.value, 10) > allowed) input.value = allowed;
        }
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
    }

    // Gallery dots (mobile)
    var viewer = root.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', function (event) {
        var dots = root.querySelectorAll('[data-ss-dot]');
        var index = (event.detail && event.detail.currentPage ? event.detail.currentPage : 1) - 1;
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      });
    }

    // Share
    var share = root.querySelector('[data-ss-share]');
    if (share) {
      var copyBtn = share.querySelector('[data-ss-copy]');
      var done = share.querySelector('[data-ss-copied]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var url = share.getAttribute('data-url');
          var title = share.getAttribute('data-title');
          if (navigator.share && mqMobile.matches) {
            navigator.share({ title: title, url: url }).catch(function () {});
            return;
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
              if (done) done.textContent = 'Link copied';
              window.setTimeout(function () { if (done) done.textContent = ''; }, 2500);
            });
          }
        });
      }
    }

    // Mobile sticky purchase bar
    var bar = root.querySelector('[data-ss-sticky]');
    var pastButtons = false;
    var typing = false;

    /* The purchase area is looked up live every time, by the ids Dawn itself uses (product-info.js and
       product-form.js address the same button by #ProductSubmitButton-{section id}), so it can never point at a
       copy of the form that has been replaced or removed from the page. The area is the .product-form__buttons
       block that holds the native Add to cart button and Shopify's dynamic checkout (Buy it now) button. */
    var SUBMIT_ID = 'ProductSubmitButton-' + sid;
    /* If an app ever copies the form (same ids) elsewhere in the page, the one inside the live product section wins */
    function mainSubmit() {
      var section = document.getElementById('MainProduct-' + sid);
      var inSection = section ? section.querySelector('[id="' + SUBMIT_ID + '"]') : null;
      return inSection || document.getElementById(SUBMIT_ID);
    }
    function purchaseArea() {
      var submit = mainSubmit();
      return submit ? submit.closest('.product-form__buttons') || submit : null;
    }
    function mainBuyNow() {
      var area = purchaseArea();
      return area ? area.querySelector('.shopify-payment-button__button') : null;
    }

    /* Returns why the bar must stay hidden, or '' when nothing is covering the page. Only the theme's own
       overlays are checked: the SS menu drawer, Dawn modals/drawers, the cart notification and the lightbox. */
    function overlayReason() {
      var drawer = document.querySelector('.ss-drawer');
      if (drawer && !drawer.hidden) return 'menu drawer';
      if (/(^|\s)overflow-hidden(-mobile|-tablet|-desktop)?(\s|$)/.test(document.body.className)) return 'modal (body class)';
      if (document.querySelector('.cart-notification.active')) return 'cart notification';
      if (document.querySelector('product-modal[open], modal-dialog[open]')) return 'lightbox/modal';
      return '';
    }
    function overlayOpen() { return overlayReason() !== ''; }

    /* Shopify's theme-preview bar (#preview-bar-iframe, shown only while previewing an unpublished theme) sits
       fixed at the bottom of the screen above everything. Keep the sticky bar (and the chat button) above it. */
    function bottomOffset() {
      var pb = document.getElementById('preview-bar-iframe');
      if (!pb) return 0;
      var cs = window.getComputedStyle(pb);
      if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
      var r = pb.getBoundingClientRect();
      if (r.height <= 0 || r.bottom < window.innerHeight - 4) return 0;
      return Math.round(Math.min(r.height, window.innerHeight / 3));
    }
    var lastOffset = -1;

    function choicesComplete() {
      var groups = root.querySelectorAll('variant-selects fieldset');
      for (var i = 0; i < groups.length; i += 1) {
        if (!groups[i].querySelector('input:checked')) return false;
      }
      return true;
    }

    function goToChoices() {
      var area = root.querySelector('[data-ss-size-area]');
      sizeMsg(true);
      if (area) area.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function syncBar() {
      if (!bar) return;
      var submit = mainSubmit();
      var add = bar.querySelector('[data-ss-sticky-add]');
      var buy = bar.querySelector('[data-ss-sticky-buy]');
      var soldout = bar.querySelector('[data-ss-sticky-soldout]');
      var unavailable = !submit || submit.hasAttribute('disabled');
      add.hidden = unavailable;
      if (buy) buy.hidden = unavailable || !mainBuyNow();
      soldout.hidden = !unavailable;
      if (unavailable && submit) soldout.textContent = submit.textContent.trim();
    }

    /* The page reserves exactly the bar's real height (strip + button + safe area) at the bottom, and focus or
       scrollIntoView keeps elements clear of it, so the bar never permanently hides content */
    function setBarSpace(show) {
      var h = show ? Math.ceil(bar.getBoundingClientRect().height) + bottomOffset() : 0;
      document.documentElement.style.setProperty('--ss-sticky-h', h + 'px');
    }

    function updateBar() {
      if (!bar) return;
      /* Persistent on mobile (2026-10-12): no longer waits for the main buttons to scroll away */
      var show = mqMobile.matches && !typing && !overlayOpen();
      var offset = bottomOffset();
      lastOffset = offset;
      bar.style.bottom = offset + 'px';
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('ss-has-stickybuy', show);
      setBarSpace(show);
      try {
        placeFloaters(show);
      } catch (e) {
        if (!show) clearLifts(); /* never leave a widget moved when the bar is hidden */
      }
      if (show) syncBar();
    }

    /* ---------- WhatsApp chat button and TrustedSite badge ----------
       Only these two app widgets are ever moved. Each is identified at runtime from what its app actually renders,
       never from a guessed tag name:
         WhatsApp    - an element showing the text "Chat with us", or linking to wa.me / api.whatsapp.com
         TrustedSite - an element whose src/href/class/id refers to trustedsite or ywxi (TrustedSite's CDN)
       The element moved is the outermost position:fixed box around that match (looking through open shadow roots).
       Anything not matched - the sticky bar, Shopify's preview bar, cookie banners, COD King, the lightbox - is
       never touched.
       While the sticky bar is visible the two are stacked upwards from the bar using their real measured sizes:
       TrustedSite sits GAP px above the bar, WhatsApp GAP px above TrustedSite when they share the same side of the
       screen (or GAP px above the bar when they do not). The shift is CSS `translate`, which leaves each app's own
       position, transform and styling untouched; when the bar hides it is removed and both return exactly to where
       their apps put them. */
    var GAP = 12;
    var floaters = [];
    var floaterDirty = true;

    function attrText(el) {
      var parts = [el.tagName, el.id, typeof el.className === 'string' ? el.className : el.getAttribute('class')];
      ['src', 'href', 'data-src', 'title', 'aria-label', 'alt', 'name'].forEach(function (n) { parts.push(el.getAttribute(n)); });
      return parts.join(' ').toLowerCase();
    }
    function ownText(el) {
      var t = '';
      for (var i = 0; i < el.childNodes.length; i += 1) if (el.childNodes[i].nodeType === 3) t += el.childNodes[i].nodeValue;
      return t;
    }
    function appMarker(el) {
      var a = attrText(el);
      if (/trustedsite|ywxi/.test(a)) return { app: 'TrustedSite', rank: 0 };
      if (/chat with us/i.test(ownText(el))) return { app: 'WhatsApp', rank: 1 };
      if (/wa\.me|api\.whatsapp\.com|wa\.link|whatsapp|wacb/.test(a)) return { app: 'WhatsApp', rank: 2 };
      return null;
    }
    function parentOf(n) { return n.parentNode && n.parentNode.nodeType === 11 ? n.parentNode.host : n.parentElement; }
    /* The OUTERMOST position:fixed box around an app element (an app may nest a fixed icon inside a fixed wrapper) */
    function fixedBox(el) {
      var n = el;
      var box = null;
      while (n && n.nodeType === 1 && n !== document.body) {
        if (window.getComputedStyle(n).position === 'fixed') box = n;
        n = parentOf(n);
      }
      return box;
    }
    /* What the widget actually shows: the union of its visible parts. An app's fixed wrapper can be much larger
       than the button it draws (for example a transparent full-width strip), so overlap is judged on this. */
    function contentRect(el) {
      var box = el.getBoundingClientRect();
      var u = null;
      var count = 0;
      var add = function (n) {
        if (count > 300 || n.nodeType !== 1) return;
        count += 1;
        var r = n.getBoundingClientRect();
        var cs = window.getComputedStyle(n);
        if (r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0' &&
            r.width < window.innerWidth * 0.7 && !(n.children.length && !/^(a|button|img|svg|iframe)$/i.test(n.tagName) && cs.backgroundColor === 'rgba(0, 0, 0, 0)' && cs.borderTopWidth === '0px')) {
          u = u ? { left: Math.min(u.left, r.left), right: Math.max(u.right, r.right), top: Math.min(u.top, r.top), bottom: Math.max(u.bottom, r.bottom) } : { left: r.left, right: r.right, top: r.top, bottom: r.bottom };
        }
        for (var i = 0; i < n.children.length; i += 1) add(n.children[i]);
        if (n.shadowRoot) for (var s = 0; s < n.shadowRoot.children.length; s += 1) add(n.shadowRoot.children[s]);
      };
      add(el);
      return u || { left: box.left, right: box.right, top: box.top, bottom: box.bottom };
    }
    /* The container an app's widget lives in: its shadow root, or the top-level <body> child it was added to */
    function appScope(el, host) {
      if (host && host.shadowRoot) return host.shadowRoot;
      var n = el;
      while (n.parentElement && n.parentElement !== document.body) n = n.parentElement;
      if (n.parentElement !== document.body || n.contains(root) || /^(main|header|footer)$/i.test(n.tagName) || n.classList.contains('shopify-section')) return null;
      return n;
    }

    function findFloaters() {
      var found = [];
      var seen = [];
      var accept = function (box, host, app, rank) {
        if (!box || box === bar || box.id === 'preview-bar-iframe' || seen.indexOf(box) !== -1) return;
        seen.push(box);
        found.push({ el: box, host: host, app: app, rank: rank });
      };
      var visit = function (node, host) {
        var els = node.querySelectorAll('*');
        for (var i = 0; i < els.length; i += 1) {
          var el = els[i];
          if (el === bar || bar.contains(el) || root.contains(el)) continue;
          var m = appMarker(el);
          if (m) accept(fixedBox(el), host, m.app, m.rank);
          if (el.shadowRoot) visit(el.shadowRoot, el);
        }
      };
      visit(document.body, null);
      /* Other fixed parts the WhatsApp app built in the same container (e.g. its round icon next to the
         "Chat with us" label), which carry no text or link of their own */
      found.filter(function (f) { return f.app === 'WhatsApp'; }).forEach(function (f) {
        var scope = appScope(f.el, f.host);
        if (!scope) return;
        var els = [scope.nodeType === 1 ? scope : null].concat(Array.prototype.slice.call(scope.querySelectorAll('*')));
        els.forEach(function (el) {
          if (!el || el.nodeType !== 1 || window.getComputedStyle(el).position !== 'fixed') return;
          accept(fixedBox(el), f.host, 'WhatsApp', 3);
        });
      });
      /* Placement order: TrustedSite (nearest the bar), the "Chat with us" element, then other WhatsApp parts */
      found.sort(function (a, b) { return a.rank - b.rank; });
      return found;
    }

    /* Every element this code has ever shifted, so the shift can always be removed even if an app re-renders
       or the widget list is rebuilt while the bar is visible */
    var lifted = [];
    function setLift(el, px) {
      if (px > 0) {
        el.style.setProperty('translate', '0 -' + px + 'px', 'important');
        el.setAttribute('data-ss-lift', String(px));
        if (lifted.indexOf(el) === -1) lifted.push(el);
      } else {
        el.style.removeProperty('translate');
        el.removeAttribute('data-ss-lift');
      }
    }
    function clearLifts() {
      lifted.forEach(function (el) { setLift(el, 0); });
      lifted = [];
    }

    var lastScan = 0;
    var scans = 0;
    function placeFloaters(show) {
      if (!show) {
        /* Bar hidden: every widget goes back exactly to where its app put it */
        clearLifts();
        return;
      }
      /* Apps can render their widget well after page load: until both apps are found, look again at most once a second */
      var apps = floaters.map(function (f) { return f.app; });
      if (!floaterDirty && scans < 30 && (apps.indexOf('WhatsApp') === -1 || apps.indexOf('TrustedSite') === -1 || floaters.length < 3) && Date.now() - lastScan > 1000) floaterDirty = true;
      if (floaterDirty) {
        var fresh = findFloaters();
        /* anything shifted earlier that is no longer in the list is put back first */
        lifted.slice().forEach(function (el) { if (!fresh.some(function (f) { return f.el === el; })) { setLift(el, 0); lifted.splice(lifted.indexOf(el), 1); } });
        floaters = fresh; floaterDirty = false; lastScan = Date.now(); scans += 1;
      }
      var limit = window.innerHeight - bottomOffset() - bar.offsetHeight - GAP; /* top of the bar minus the gap */
      var placed = [];
      floaters.forEach(function (f) {
        var el = f.el;
        if (!el.isConnected) { floaterDirty = true; return; }
        var applied = parseFloat(el.getAttribute('data-ss-lift') || '0') || 0;
        var c = contentRect(el);
        var n = { left: c.left, right: c.right, top: c.top + applied, bottom: c.bottom + applied }; /* where the app put it */
        /* Safety: only widgets whose visible part sits in the lower part of the screen are moved */
        var widget = n.right > n.left && n.bottom > n.top && n.top > window.innerHeight * 0.4;
        var lift = 0;
        if (show && widget) {
          /* Lowest free slot: start GAP px above the bar and step above any widget already placed that it would touch */
          var h = n.bottom - n.top;
          var bottom = Math.min(limit, n.bottom);
          for (var guard = 0; guard < 6; guard += 1) {
            var hit = null;
            placed.forEach(function (p) {
              if (n.left < p.right && n.right > p.left && bottom - h < p.bottom + GAP && bottom > p.top - GAP) hit = hit && hit.top < p.top ? hit : p;
            });
            if (!hit) break;
            bottom = hit.top - GAP;
          }
          lift = Math.max(0, Math.ceil(n.bottom - bottom));
        }
        if (lift !== applied) setLift(el, lift);
        if (widget) placed.push({ left: n.left, right: n.right, top: n.top - lift, bottom: n.bottom - lift });
      });
    }

    if (bar && purchaseArea()) {
      /* The bar is position: fixed. Inside the section it can be trapped by any ancestor that creates a containing
         block (transform, filter, contain, will-change — e.g. from Shopify's preview tooling or an app's CSS), which
         makes it sit at the bottom of that ancestor instead of the screen. Move it to <body>, as Dawn does with its
         modals, so it is always positioned against the viewport. */
      Array.prototype.slice.call(document.querySelectorAll('body > [data-ss-sticky][data-ss-for="' + sid + '"]')).forEach(function (old) {
        if (old !== bar) old.remove();
      });
      bar.setAttribute('data-ss-for', sid);
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'true');
      var ticking = false;
      var measure = function () {
        ticking = false;
        var area = purchaseArea();
        if (!area) return;
        var r = area.getBoundingClientRect();
        /* Completely above the viewport: the bottom edge of the buttons block has passed the top of the screen */
        var past = r.height > 0 && r.bottom <= 0;
        if (past !== pastButtons || bottomOffset() !== lastOffset) {
          pastButtons = past;
          updateBar();
        } else if (bar.classList.contains('is-visible')) {
          try { placeFloaters(true); } catch (e) { /* a widget error must never affect the bar */ }
        }
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          try { measure(); } catch (e) { ticking = false; }
        });
      };
      /* Capture phase on document also catches scrolling of an inner scroll container, not only the window */
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      window.addEventListener('pageshow', onScroll);
      /* End of a touch scroll / momentum scroll: measure once more from the final position */
      window.addEventListener('scrollend', onScroll, { passive: true });
      document.addEventListener('touchend', onScroll, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
        window.visualViewport.addEventListener('resize', onScroll, { passive: true });
      }
      measure();

      bar.querySelector('[data-ss-sticky-add]').addEventListener('click', function () {
        if (!choicesComplete()) return goToChoices();
        var submit = mainSubmit();
        if (submit && !submit.hasAttribute('disabled')) submit.click();
      });
      var stickyBuy = bar.querySelector('[data-ss-sticky-buy]');
      if (stickyBuy) {
        stickyBuy.addEventListener('click', function () {
          if (!choicesComplete()) return goToChoices();
          var buyNow = mainBuyNow();
          if (buyNow && !buyNow.disabled) buyNow.click();
        });
      }
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { setBarSpace(bar.classList.contains('is-visible')); }).observe(bar);
      }

      document.addEventListener('focusin', function (event) {
        var t = event.target;
        typing = !!(t && t.matches && t.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]'));
        updateBar();
      });
      document.addEventListener('focusout', function () {
        window.setTimeout(function () {
          var t = document.activeElement;
          typing = !!(t && t.matches && t.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]'));
          updateBar();
        }, 50);
      });

      if ('MutationObserver' in window) {
        var overlayWatch = new MutationObserver(updateBar);
        overlayWatch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        var ssDrawer = document.querySelector('.ss-drawer');
        if (ssDrawer) overlayWatch.observe(ssDrawer, { attributes: true, attributeFilter: ['hidden'] });
        var notification = document.querySelector('.cart-notification');
        if (notification) overlayWatch.observe(notification, { attributes: true, attributeFilter: ['class'] });
        var submit = mainSubmit();
        if (submit) new MutationObserver(syncBar).observe(submit, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
        var areaNow = purchaseArea();
        if (areaNow) new MutationObserver(syncBar).observe(areaNow, { childList: true, subtree: true });
        /* Apps add their widgets to <body> after load: re-scan when <body>'s direct children change */
        new MutationObserver(function () {
          floaterDirty = true;
          if (bar.classList.contains('is-visible')) placeFloaters(true);
        }).observe(document.body, { childList: true });
      }
      mqMobile.addEventListener ? mqMobile.addEventListener('change', updateBar) : mqMobile.addListener(updateBar);
      syncBar();
      updateBar();
    }

    // Re-apply after Dawn refreshes the product info for a new variant
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== sid) return;
        applyQty();
        syncBar();
      });
    }
    applyQty();
  }

  function init() {
    document.querySelectorAll('[data-ss-recent]').forEach(initRecent);
    document.querySelectorAll('[data-ss-pdp]').forEach(function (root) {
      initProduct(root);
      saveRecent(root.getAttribute('data-ss-handle'));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
